import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-5 right-5 z-[100] flex flex-col gap-2 pointer-events-none" }
const _hoisted_2 = { class: "text-base flex-shrink-0 mt-0.5" }
const _hoisted_3 = { class: "flex-1 leading-snug" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(['pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg border text-sm font-medium max-w-sm w-full', _ctx.colorMap[toast.type]])
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.iconMap[toast.type]), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(toast.message), 1),
              _createElementVNode("button", {
                class: "flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity ml-1",
                onClick: ($event: any) => (_ctx.remove(toast.id))
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))], 8, _hoisted_4)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}